// src/firebase.js
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  databaseURL: "https://digisavvy-32a41-default-rtdb.firebaseio.com",


  apiKey: "AIzaSyB7ZbnpT8Sk-3P9rdNYF5ALSAjTDZysYYU",
  authDomain: "digisavvy-32a41.firebaseapp.com",
  projectId: "digisavvy-32a41",
  storageBucket: "digisavvy-32a41.firebasestorage.app",
  messagingSenderId: "184679857686",
  appId: "1:184679857686:web:ad371b7c83a4fed0c87f37"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = firebaseApp.firestore();
export const storage = firebaseApp.storage();
